import {SidePanel} from '@github-ui/side-panel'
import {XIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import type {RefObject} from 'react'

import {ArtifactCopyButton} from './ArtifactCopyButton'
import {ArtifactPanelBody, type PanelArtifact} from './ArtifactPanelContent'
import styles from './ArtifactsSidePanelOverlay.module.css'
import {ArtifactsTabBar, type TabItem} from './ArtifactsTabBar'

type ArtifactsSidePanelOverlayProps = {
  open: boolean
  onClose: () => void
  tabs: TabItem[]
  activeId: string | null
  activeArtifact: PanelArtifact | null
  onActivate: (id: string) => void
  onPromoteOverflowTab: (id: string) => void
  onCloseTab?: (id: string) => void
  returnFocusRef: RefObject<HTMLElement | null>
}

export function ArtifactsSidePanelOverlay({
  open,
  onClose,
  tabs,
  activeId,
  activeArtifact,
  onActivate,
  onPromoteOverflowTab,
  onCloseTab,
  returnFocusRef,
}: ArtifactsSidePanelOverlayProps) {
  return (
    <SidePanel
      open={open}
      defaultCloseElement="overlay"
      onClose={onClose}
      returnFocusRef={returnFocusRef}
      aria-label="Artifacts"
      width="var(--artifacts-panel-width, 40%)"
    >
      <div className={styles.Panel}>
        <ArtifactsTabBar
          tabs={tabs}
          activeId={activeId}
          onActivate={onActivate}
          onPromoteOverflowTab={onPromoteOverflowTab}
          onCloseTab={onCloseTab}
          maxVisibleTabs={3}
          trailingActions={
            <>
              <ArtifactCopyButton artifact={activeArtifact} />
              <IconButton icon={XIcon} variant="invisible" aria-label="Close panel" onClick={onClose} />
            </>
          }
        />
        <div
          className={styles.Content}
          id={activeArtifact ? `artifact-panel-${activeArtifact.id}` : undefined}
          role={activeArtifact ? 'tabpanel' : undefined}
          aria-labelledby={activeArtifact ? `artifact-tab-${activeArtifact.id}` : undefined}
        >
          {activeArtifact && <ArtifactPanelBody artifact={activeArtifact} />}
        </div>
      </div>
    </SidePanel>
  )
}
